import Account from '@/orm/models/Account/Account';

export default function useDowngradePlan() {
  function downgradePlan({ planId, periodId, paymentMethodId }) {
    return Account.api().downgradePlan({ planId, periodId, paymentMethodId });
  }

  return {
    downgradePlan,
  };
}
